import Link from 'next/link';
import { Badge, ImageView } from '../../../../components/ui';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { Message } from '../../types';
import styles from './MessageList.module.scss';

export interface MessageListProps {
  messages: Array<Message>;
  messageDetailPath: string;
  formatDate: (date: string, format: string) => string;
}

/*:
 * メッセージ一覧
 * デザイン共通
 */
function MessageList({ messages, messageDetailPath, formatDate }: MessageListProps) {
  return (
    <ul className={styles.componentStyle}>
      {messages.map((message) => (
        <li key={message.id}>
          <Link
            className={`${styles.itemLink}`}
            prefetch={false}
            href={{ pathname: `${messageDetailPath}/${message.id}` }}
          >
            <div className={`${styles.itemDate} ${utilsStyles.textBold}`}>
              {formatDate(message.sendedAt, 'yyyy年MM月dd日 HH:mm')}
            </div>
            <div className={styles.profile}>
              {!message.readFlag && (
                <div className={styles.itemBadge}>
                  <Badge color={'primary'} />
                </div>
              )}
              {message.fromImageUrl && (
                <div className={styles.profileImage}>
                  <ImageView src={message.fromImageUrl} alt={message.fromName} isCircled />
                </div>
              )}
              <p className={`${styles.profileName} ${utilsStyles.textBold} ${utilsStyles.textEllipsis}`}>
                {message.fromName}
              </p>
            </div>
            <hr className={`${utilsStyles.mtXSmall} ${utilsStyles.grayBgColor}`} />
            <div className={`${styles.itemTitle} ${utilsStyles.mtXSmall} ${utilsStyles.textBold}`}>{message.title}</div>
            <div
              className={`${styles.itemDescription} ${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}
              // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
              dangerouslySetInnerHTML={{ __html: message.excerpt }}
            />
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default MessageList;
